import { render, staticRenderFns } from "./ZohoSalesOrder.vue?vue&type=template&id=faffe0dc"
import script from "./ZohoSalesOrder.vue?vue&type=script&lang=js"
export * from "./ZohoSalesOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports